/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_DqInputs */



/**
* | output |
* | --- |
* | "DQ" |
*
* @param {Sanction_Level_DqInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_dq = /** @type {((inputs?: Sanction_Level_DqInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_DqInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DQ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descalificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("DQ")
	if (locale === "it") return /** @type {LocalizedString} */ ("DQ")
	return /** @type {LocalizedString} */ ("DQ")
});